import type { AnyAction } from 'redux';

import { Cookies } from 'ovpn-ui-toolkit';

import { authRoutines } from './auth.routines';

const tokenId = 'cvpn_token';
const ssoTokenId = 'sso_token';

const initialState = {
    ssoToken: Cookies.getCookie(ssoTokenId),
    token: Cookies.getCookie(tokenId),
    tenantAuth: {
        type: null,
        loading: false,
    },
};

// TODO: review if works correct
// biome-ignore lint/style/useDefaultParameterLast: ok
export function authReducer(state = initialState, action: AnyAction) {
    switch (action.type) {
        case authRoutines.setAuthToken.TRIGGER:
            return {
                ...state,
                ssoToken: Cookies.getCookie(ssoTokenId),
                token: Cookies.getCookie(tokenId),
            };

        case authRoutines.getTenantAuth.TRIGGER:
            return {
                ...state,
                tenantAuth: {
                    ...state.tenantAuth,
                    loading: true,
                },
            };

        case authRoutines.getTenantAuth.FAILURE:
            return {
                ...state,
                tenantAuth: {
                    ...state.tenantAuth,
                    loading: false,
                },
            };

        case authRoutines.getTenantAuth.SUCCESS:
            return {
                ...state,
                tenantAuth: {
                    ...state.tenantAuth,
                    type: action.payload.type,
                    loading: false,
                },
            };

        case authRoutines.editTenantAuth.SUCCESS:
            return {
                ...state,
                tenantAuth: {
                    ...state.tenantAuth,
                    type: action.payload.type,
                },
            };

        default:
            return state;
    }
}

// TODO SC2
// export function extendAuthReducer(
//     externalReducerMap: ReducerMap<Record<string, unknown>>,
//     externalInitialState: Immutable<Record<string, unknown>>,
// ): Reducer {
//     return createReducer(
//         { ...reducerMap, ...externalReducerMap },
//         { ...initialState, ...externalInitialState },
//     );
// }
